import type { Room } from 'livekit-client';
import { sameBreakoutGroup, type HuddleBreakout } from '@avslack/shared';

/**
 * A feliratkozas igazitasa a kiscsoporthoz: csak a sajat csoportunk savjait
 * toltjuk le (docs/19-kiscsoportos-szobak.html).
 *
 * Idoszak nelkul MINDENKIROL feliratkozunk - a kiscsoportos idoszak vegen ez hozza
 * vissza a kozos beszelgetest. A leiratkozott sav nem er el hozzank; a LiveKit
 * `TrackUnsubscribed` esemenye a meglevo kezelovel leveszi a hangot es a kepet.
 *
 * NEM kikenyszeritett elkulonites: a kliens szur (lasd a terv 2. szakasza).
 * A tag kulcsa a LiveKit-identitas (felhasznalo-azonosito, vendegnel `guest_<id>`).
 */
export function applyBreakoutFilter(room: Room, breakout: HuddleBreakout | null): void {
  const me = room.localParticipant.identity;
  room.remoteParticipants.forEach((participant) => {
    const allowed = sameBreakoutGroup(breakout, me, participant.identity);
    participant.trackPublications.forEach((publication) => {
      if (publication.isSubscribed !== allowed) publication.setSubscribed(allowed);
    });
  });
}
